import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
import dayjs from "dayjs";

const salaryApi = factory.get("salary");

const initialState = {
  results: {
    loading: false,
    data: [],
    total: 0,
    sum: 0,
    filters: {
      skip: 0,
      take: 1000,
      page: 0,
      department_id: null,
      user_id: null,
      date: dayjs().format("YYYY-MM-01"),
      is_paid: null,
      is_approved: null,
      fingerprint_id: null,
      is_late: null,
    },
    is_ready: false,
    is_calculated: true,
    filters_dialog: false,
  },
  print_salary: {
    dialog: false,
    selected_employee: [],
  },
  calculate_salary: {
    loading: false,
    dialog: false,
    form: {
      date: dayjs().format("YYYY-MM-DD"),
      user_id: null,
      department_id: null,
    },
  },
  approved_paid: {
    loading: false,
    dialog: false,
    form: {
      type: "paid",
      salary_id: [],
      status: 1,
    },
  },
  edit_attendance: {
    loading: false,
    dialog: false,
    form: {
      salary_id: null,
      days: 0,
      hours: 0,
    },
  },
};

export const salary = createSlice({
  name: "salary",
  initialState,
  reducers: {
    clearResults: (state, action) => {
      state.results.data = [];
      state.results.total = 0;
      state.results.sum = 0;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setDialog: (state, action) => {
      state.calculate_salary.dialog = !state.calculate_salary.dialog;
    },
    setgApprovedPaidDialog: (state, { payload }) => {
      if (payload?.type) {
        state.approved_paid.form.type = payload.type;
        state.approved_paid.form.salary_id = payload.salary_id;
      } else {
        state.approved_paid.form = initialState.approved_paid.form;
      }
      state.approved_paid.dialog = !state.approved_paid.dialog;
    },
    setgEditAttendanceDialog: (state, { payload }) => {
      if (payload?.id) {
        state.edit_attendance.form.salary_id = payload.id;
        state.edit_attendance.form.hours = payload.hours;
        state.edit_attendance.form.days = payload.days;
      } else {
        state.edit_attendance.form = initialState.edit_attendance.form;
      }
      state.edit_attendance.dialog = !state.edit_attendance.dialog;
    },
    setDataTable: (state, { payload }) => {
      if (payload.data.length > 0) {
        state.results.data = payload.data;
        state.results.total = payload.total;
        state.results.sum = payload.sum;
      } else {
        state.results.data = [];
        state.results.total = 0;
      }
    },
    setById: (state, { payload }) => {
      for (const key in state.calculate_salary.form) {
        if (payload[key]) {
          state.calculate_salary.form[key] = payload[key];
        }
      }
      state.calculate_salary.form.user_id = {
        id: payload.user_id,
        full_name: payload.user_name,
        department_name: payload.department,
      };
    },
    resetForm: (state, action) => {
      state.calculate_salary.form = initialState.calculate_salary.form;
    },
    setFiltersDialog: (state, action) => {
      state.results.filters_dialog = !state.results.filters_dialog;
    },
    setFilters: (state, { payload }) => {
      state.results.filters = {
        ...state.results.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.results.is_ready = false;
      state.results.filters.page = 0;
      state.results.filters.skip = 0;
      state.results.filters.take = 1000;
      state.results.filters.department_id = null;
      state.results.filters.user_id = null;
      state.results.filters.is_paid = null;
      state.results.filters.is_approved = null;
      state.results.filters.fingerprint_id = "";
      state.results.filters.is_late = null;
    },
    setIsReady: (state, { payload }) => {
      state.results.is_ready = payload;
    },
    setIsCalculated: (state, { payload }) => {
      state.results.is_calculated = payload;
    },
    setPrintDialog: (state, { payload }) => {
      if (payload) {
        state.print_salary.selected_employee = payload;
      } else {
        state.print_salary.selected_employee = [];
      }
      state.print_salary.dialog = !state.print_salary.dialog;
    },
  },
});

export const {
  clearResults,
  setLoading,
  setDialog,
  setDataTable,
  setById,
  resetForm,
  setFilters,
  setFiltersDialog,
  resetFilters,
  setgApprovedPaidDialog,
  setgEditAttendanceDialog,
  setIsReady,
  setIsCalculated,
  setPrintDialog,
} = salary.actions;

export default salary.reducer;

//axios
const getAll = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("results"));
    const filters = getState().salary.results.filters;
    const filters_ = {
      ...filters,
      department_id: filters.department_id?.id || null,
      user_id: filters.user_id?.id || null,
    };
    const res = await salaryApi.getAll(filters_);
    dispatch(setDataTable(res.data));
    dispatch(setLoading("results"));
  } catch (err) {
    dispatch(setDataTable(err.response));
    dispatch(setLoading("results"));
    throw new Error(err);
  }
};
const calculate = (data) => async (dispatch, getState) => {
  try {
    dispatch(setIsReady(false));
    dispatch(setLoading("calculate_salary"));
    let date = `${dayjs(data.date).format("YYYY-MM")}-01`;
    const filters = {
      ...data,
      user_id: data.user_id?.id || null,
      department_id: data.department_id?.id || null,
      date,
    };
    await salaryApi.calculate(filters);

    dispatch(setLoading("calculate_salary"));
    dispatch(
      showNotification({
        message: "تمت العملية ... جارِ احتساب الرواتب",
        type: "success",
      })
    );
    dispatch(clearResults());
    dispatch(setDialog());
    dispatch(setIsCalculated(false));
    let interval = setInterval(() => {
      dispatch(checkSalaryStatus(date)).then((res) => {
        if (res) {
          clearInterval(interval);
          dispatch(setIsCalculated(true));
        } else {
          dispatch(setIsCalculated(false));
        }
      });
    }, 5000);
  } catch (err) {
    dispatch(setLoading("calculate_salary"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteByMonth = (date) => async (dispatch) => {
  try {
    await salaryApi.deleteByMonth(date);
    dispatch(
      showNotification({
        message: "تم حذف  الرواتب بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    return true;
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const salaryStatus = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("approved_paid"));
    const form = {
      salary_id: data.salary_id.length > 0 ? data.salary_id : "all",
    };
    if (data.type === "paid") {
      form.is_paid = data.status;
    } else {
      form.is_approved = data.status;
    }

    await salaryApi[data.type](form);

    dispatch(
      showNotification({
        message: "تم تحديد الحالة بنجاح",
        type: "success",
      })
    );
    dispatch(setLoading("approved_paid"));
    dispatch(setgApprovedPaidDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("approved_paid"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const changeAttendance = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("edit_attendance"));
    await salaryApi.changeAttendance(data);
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(setLoading("edit_attendance"));
    dispatch(setgEditAttendanceDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("edit_attendance"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const checkSalaryStatus = (date) => async (dispatch, getState) => {
  try {
    // dispatch(setIsReady(false));
    dispatch(resetFilters());
    //check if salary is calculated from server and it is calculated & ready
    // const filters = getState().salary.results.filters;
    dispatch(setLoading("results"));
    const res = await salaryApi.checkSalaryStatus(date);
    let status = false;
    const { is_ready, is_calculated } = res.data.data;
    if (is_ready && is_calculated) {
      dispatch(setIsReady(true));
      status = true;
      // dispatch(
      //   showNotification({
      //     message: "تم حساب الرواتب بنجاح",
      //     type: "success",
      //   })
      // );
    } else if (is_calculated) {
      dispatch(
        showNotification({
          message: "يرجى الانتظار قليلا... يتم حساب الرواتب الان",
          type: "info",
        })
      );
      dispatch(setDataTable({ data: [], total: 0 }));
      dispatch(setIsReady(false));
      status = false;
    } else {
      dispatch(
        showNotification({
          message: "راتب هذا الشهر غير محسوب ... يرجى حساب الرواتب اولا",
          type: "info",
        })
      );
      dispatch(setDataTable({ data: [], total: 0 }));
      dispatch(setIsReady(false));
      status = false;
    }
    dispatch(setLoading("results"));
    return status;
  } catch (err) {
    throw new Error(err);
  }
};

export const Salary = {
  getAll,
  calculate,
  deleteByMonth,
  salaryStatus,
  changeAttendance,
  checkSalaryStatus,
};
